/**
 * Badge « série » de la barre — SÉRIE DE SEMAINES (Option A, façon app de sport).
 * Compte les semaines consécutives où l'objectif hebdo a été atteint (alimenté par
 * TOUTE session complétée, cf. touchWeeklyRhythm). Multi-flammes = intensité de la
 * série (1 → <4 sem, 2 → 4-7, 3 → ≥8) + le nombre de semaines tenues.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { Flame } from "lucide-react";
import { weeklyRhythmApi, type WeeklyRhythm } from "../lib/api";

export function StreakBadge() {
  const { t } = useTranslation();
  const [rhythm, setRhythm] = React.useState<WeeklyRhythm | null>(null);
  const [showTooltip, setShowTooltip] = React.useState(false);

  React.useEffect(() => {
    weeklyRhythmApi.getMine().then(setRhythm).catch(() => {});
  }, []);

  const weeks = rhythm?.streak.current ?? 0;
  if (weeks === 0) return null;

  const longest = rhythm?.streak.longest ?? weeks;
  const flames = weeks >= 8 ? 3 : weeks >= 4 ? 2 : 1;

  return (
    <div
      className="relative inline-flex items-center gap-1 px-2 py-1 rounded-full bg-orange-50 border border-orange-200 cursor-default"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      title={t("streak.weeksShort", { count: weeks })}
    >
      <span className="inline-flex items-center">
        {Array.from({ length: flames }).map((_, i) => (
          <Flame key={i} className="h-4 w-4 text-orange-500" style={i ? { marginLeft: -5 } : undefined} />
        ))}
      </span>
      <span className="text-sm font-bold text-orange-700">{weeks}</span>
      {showTooltip && (
        <div className="absolute top-full mt-2 right-0 z-30 w-60 px-3 py-2 bg-white rounded-lg shadow-lg border text-xs">
          <div className="font-semibold mb-1" style={{ color: "#384872" }}>{t("streak.weeksTitle")}</div>
          <div className="text-muted-foreground"><strong>{t("streak.weeksCurrent", { count: weeks })}</strong></div>
          <div className="text-muted-foreground"><strong>{t("streak.weeksLongest", { count: longest })}</strong></div>
          <div className="text-muted-foreground mt-1 text-[10px]">{t("streak.weeksRule")}</div>
        </div>
      )}
    </div>
  );
}
